const accessStatus = {
  employee: 'ENTRADA PERMITIDA',
  employee1: 'ENTRADA BLOQUEADA',
  company: 'LIBERADA',
  company1: 'NÃO LIBERADA'
};

export default accessStatus;
